<div class="dashboard-container">
  <div class="dashboard-content">
      <!-- Link per gli stylesheet per le icone PrimeNG -->
      <link rel="stylesheet" href="https://unpkg.com/primeicons/primeicons.css" />

      <!-- Titolo della dashboard -->
      <div class="dashboard-header">
        <span class="dashboard-title">
          <span class="material-icons" style="vertical-align: middle; margin-right: 8px; font-size: 28px; color: #29A0A4;">dashboard</span>
          Richieste anno {{annoCorrente}}
          <span class="total-requests-badge">Totale: <span style="font-size: 1.2em;">{{statsRichieste.totaleRichieste}}</span></span>
          <!-- Indicatore ambiente di test -->
          <span *ngIf="isTestEnvironment" class="dashboard-test-badge">TEST</span>
        </span>
        <button class="stat-button header-view-all" pTooltip="Visualizza tutte le richieste" tooltipPosition="top" (click)="visualizzaRichieste('tutte')">
          <span class="material-icons icon-in-button">view_list</span>
          Visualizza tutte
        </button>
      </div>

      <!-- Statistiche richieste -->
      <div class="stats-container">
        <!-- Richieste in preparazione -->
        <div class="stat-card" style="background-color: #f5f5f5; border-left: 5px solid #2196F3;">
          <div class="stat-header" style="color: #2196F3; font-weight: 600; font-size: 1.1em; margin-bottom: 15px;">
            In preparazione
          </div>
          <div class="stat-value-container">
            <div class="stat-value" style="color: #2196F3;">{{statsRichieste.conteggioPerStato['IN PREPARAZIONE'] || 0}}</div>
            <span class="material-icons" style="color: #2196F3;">edit_document</span>
          </div>
          <button class="stat-button"
            [pTooltip]="'Visualizza richieste in preparazione'"
            tooltipPosition="top"
            (click)="visualizzaRichieste('in preparazione')">
            <span class="material-icons icon-in-button" style="color: #2196F3;">visibility</span>
            Visualizza
          </button>
        </div>

        <!-- Richieste presentate -->
        <div class="stat-card" style="background-color: #f5f5f5; border-left: 5px solid #eabf51;">
          <div class="stat-header" style="color: #eabf51; font-weight: 600; font-size: 1.1em; margin-bottom: 15px;">
            Presentate
          </div>
          <div class="stat-value-container">
            <div class="stat-value" style="color: #eabf51;">{{statsRichieste.conteggioPerStato['PRESENTATA'] || 0}}</div>
            <span class="material-icons" style="color: #eabf51;">assignment_turned_in</span>
          </div>
          <button class="stat-button" pTooltip="Visualizza richieste presentate" (click)="visualizzaRichieste('presentata')">
            <span class="material-icons icon-in-button" style="color: #eabf51;">visibility</span>
            Visualizza
          </button>
        </div>

        <!-- Richieste da finanziare -->
        <div class="stat-card" style="background-color: #f5f5f5; border-left: 5px solid #9C27B0;">
          <div class="stat-header" style="color: #9C27B0; font-weight: 600; font-size: 1.1em; margin-bottom: 15px;">
            Da Finanziare
          </div>
          <div class="stat-value-container">
            <div class="stat-value" style="color: #9C27B0;">{{statsRichieste.conteggioPerStato['DA FINANZIARE'] || 0}}</div>
            <span class="material-icons" style="color: #9C27B0;">pending</span>
          </div>
          <button class="stat-button" pTooltip="Visualizza richieste da finanziare" tooltipPosition="top" (click)="visualizzaRichieste('da finanziare')">
            <span class="material-icons icon-in-button" style="color: #9C27B0;">visibility</span>
            Visualizza
          </button>
        </div>

        <!-- Richieste finanziate -->
        <div class="stat-card" style="background-color: #f5f5f5; border-left: 5px solid #00BCD4;">
          <div class="stat-header" style="color: #00BCD4; font-weight: 600; font-size: 1.1em; margin-bottom: 15px;">
            Finanziate
          </div>
          <div class="stat-value-container">
            <div class="stat-value" style="color: #00BCD4;">{{statsRichieste.conteggioPerStato['FINANZIATA'] || 0}}</div>
            <span class="material-icons" style="color: #00BCD4;">payments</span>
          </div>
          <button class="stat-button" pTooltip="Visualizza richieste finanziate" tooltipPosition="top" (click)="visualizzaRichieste('finanziata')">
            <span class="material-icons icon-in-button" style="color: #00BCD4;">visibility</span>
            Visualizza
          </button>
        </div>

        <!-- Richieste in rendicontazione -->
        <div class="stat-card" style="background-color: #f5f5f5; border-left: 5px solid #009688;">
          <div class="stat-header" style="color: #009688; font-weight: 600; font-size: 1.1em; margin-bottom: 15px;">
            In Rendicontazione
          </div>
          <div class="stat-value-container">
            <div class="stat-value" style="color: #009688;">{{statsRichieste.conteggioPerStato['IN RENDICONTAZIONE'] || 0}}</div>
            <span class="material-icons" style="color: #009688;">pending_actions</span>
          </div>
          <button class="stat-button" pTooltip="Visualizza richieste in rendicontazione" tooltipPosition="top" (click)="visualizzaRichieste('in rendicontazione')">
            <span class="material-icons icon-in-button" style="color: #009688;">visibility</span>
            Visualizza
          </button>
        </div>

        <!-- Richieste rendicontate -->
        <div class="stat-card" style="background-color: #f5f5f5; border-left: 5px solid #4CAF50;">
          <div class="stat-header" style="color: #4CAF50; font-weight: 600; font-size: 1.1em; margin-bottom: 15px;">
            Rendicontate
          </div>
          <div class="stat-value-container">
            <div class="stat-value" style="color: #4CAF50;">{{statsRichieste.conteggioPerStato['RENDICONTATA'] || 0}}</div>
            <span class="material-icons" style="color: #4CAF50;">receipt_long</span>
          </div>
          <button class="stat-button" pTooltip="Visualizza richieste rendicontate" tooltipPosition="top" (click)="visualizzaRichieste('rendicontata')">
            <span class="material-icons icon-in-button" style="color: #4CAF50;">visibility</span>
            Visualizza
          </button>
        </div>

        <!-- Richieste liquidate -->
        <div class="stat-card" style="background-color: #f5f5f5; border-left: 5px solid #008000;">
          <div class="stat-header" style="color: #008000; font-weight: 600; font-size: 1.1em; margin-bottom: 15px;">
            Liquidate
          </div>
          <div class="stat-value-container">
            <div class="stat-value" style="color: #008000;">{{statsRichieste.conteggioPerStato['LIQUIDATA'] || 0}}</div>
            <span class="material-icons" style="color: #008000;">paid</span>
          </div>
          <button class="stat-button" pTooltip="Visualizza richieste liquidate" tooltipPosition="top" (click)="visualizzaRichieste('liquidata')">
            <span class="material-icons icon-in-button" style="color: #008000;">visibility</span>
            Visualizza
          </button>
        </div>
      </div>

      <!-- Sezione Mappa -->
      <div class="map-section">
        <!-- <div class="map-header">
          <h2 class="map-title">
            <span class="material-icons" style="vertical-align: middle; margin-right: 8px; font-size: 24px;">map</span>
            Mappa Richieste
          </h2>
          <div class="map-controls">
          </div>
        </div> -->
        <div class="map-wrapper">
          <div #map id="map" class="map"></div>
          <!-- Tooltip personalizzato per i comuni -->
          <div #mapTooltip id="map-tooltip" class="map-tooltip">
            <strong id="tooltip-title"></strong>
            <div id="tooltip-stato" class="tooltip-stato"></div>
          </div>
        </div>
      </div>
  </div>

  <!-- Toast per messaggi popup -->
  <p-toast position="top-right"></p-toast>
</div>
